import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Home/Footer/Footer";
import styles from "./about.module.css";

const About = () => {
  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <span className={styles.eyebrow}>The Brand</span>
        <h1 className={styles.title}>About Us</h1>

        <p className={styles.lead}>
          LORMAMI is a Nigerian-based, futuristic lifestyle and fashion brand.
          Founded by fashion designer, tailor and stylist{" "}
          <strong>Oluwatoba Khalia</strong>, the brand is known for its
          aesthetically appealing streetwear — and its community.
        </p>

        <p className={styles.body}>
          The brand is highly active in the local scene and recently concluded
          its public runway performance, <em>“Ballads of Freedom”</em> — a
          runway run to live music, in a public space, free and open to
          everyone.
        </p>

        <p className={styles.pull}>
          If community-centric, intentional design, social awareness and
          aesthetically pleasing pieces are your vibe — you’ve found home.
        </p>

        <div className={styles.actions}>
          <Link to="/shop" className={styles.btnPrimary}>
            Shop the Collection
          </Link>
          <Link to="/#preorder" className={styles.btnGhost}>
            Join the Community
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
